/**
 * 被邀请人填码相关 OpenReplay 事件名（fe-spec §3.9.1，EDG-557）。
 *
 * 旧事件 `login_invitecode_*` / `invitecode_page_*` 已停用（§3.9.3）。
 */
export const INVITE_CODE_EVENTS = {
  /** 点「Have an invite code?」或「✓ Invite code … applied」 */
  entryTap: "inv_code_entry_tap",
  /** 点 Apply（非空），结果确定后上报 */
  submit: "inv_code_submit",
  /** 清空后点 Apply（移除） */
  remove: "inv_code_remove",
} as const;

/** 入口所在页面：起始页 / 登录页 */
export type InviteCodeEntryPage = "intro" | "sign_in";
